(function FranchisePaymentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FranchisePayment',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#franchisepayment-franchise_credit_card').change(function showHideNew() {
			if ($(this).val() === 'other') {
				$('.new-card').each(function showFields() {
					$(this).removeClass('hidden');
				});
			} else {
				$('.new-card').each(function showFields() {
					$(this).addClass('hidden');
				});
			}
		});
	};

	form.confirmation = function confirmation(response)
	{
		Adzuki.CustomConfirm({
			body   : response.data.message,
			confirm: function onConfirm() {
				$('#franchisepayment-bypass_confirmation').val('1');

				$(form.element).submit();
			},
			cancel: function onCancel() {
				// do nothing
			}
		});
	};
}(jQuery, window.Adzuki || {}));
